import types from "store/actionTypes";

export const showNotification = ({ message, appearance }) => ({
  type: types.SHOW_NOTIFICATION,
  message,
  appearance,
});

export const showSuccessNotification = (message) => ({
  type: types.SHOW_NOTIFICATION_SUCCESS,
  message,
});

export const showFailureNotification = (message) => ({
  type: types.SHOW_NOTIFICATION_FAILURE,
  message,
});

export const resetNotification = () => ({
  type: types.RESET_NOTIFICATION,
});
